"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgeRangeToJSON = exports.AgeRangeFromJSONTyped = exports.AgeRangeFromJSON = exports.instanceOfAgeRange = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the AgeRange interface.
 */
function instanceOfAgeRange(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAgeRange = instanceOfAgeRange;
function AgeRangeFromJSON(json) {
    return AgeRangeFromJSONTyped(json, false);
}
exports.AgeRangeFromJSON = AgeRangeFromJSON;
function AgeRangeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'min': !(0, runtime_1.exists)(json, 'min') ? undefined : json['min'],
        'max': !(0, runtime_1.exists)(json, 'max') ? undefined : json['max'],
    };
}
exports.AgeRangeFromJSONTyped = AgeRangeFromJSONTyped;
function AgeRangeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'min': value.min,
        'max': value.max,
    };
}
exports.AgeRangeToJSON = AgeRangeToJSON;
